import { compose } from 'recompose';
import apiInterceptor from '../../../../api/interceptor';
import SalesInvoiceDetail from './SalesInvoiceDetail';
import { salesInvoiceApi } from '../../../common/base.api';

const composedSalesInvoiceDetail = compose(apiInterceptor({ ...salesInvoiceApi }))(SalesInvoiceDetail);

export default composedSalesInvoiceDetail;
